import { useEffect, useState } from "react";
import "../../css/settings/Sessions.css";
import { useTranslation } from "react-i18next";
import { domain } from "../Links/Links";

function Sessions({ theme }) {
  const { t } = useTranslation();

  const [sessions, setSessions] = useState([]);
  const [loadingStatus, setLoadingStatus] = useState(false);
  useEffect(() => {
    document.title = t("Hiket, Sessions");
    const xhr = new XMLHttpRequest();
    xhr.open("GET", domain + "/sessions_api/", true);
    xhr.withCredentials = true;
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);
        setSessions(data);
        setTimeout(() => {
          setLoadingStatus(true);
        }, 0);
      }
    };
    xhr.send();
  }, []);

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>{t('Sessions')}</div>
      <div className="contentDiv padding12 gap12">
        {!loadingStatus ? (
          <div className="fkgjjjrn4">
            {Array.from({ length: 3 }).map((_, i) => (
              <div className="kfjjej3kv" key={i}>
                <div className={`jfkkkeoo3 shimmer ${theme}`}></div>
                <div className={`fghtrrthg shimmer ${theme}`}></div>
              </div>
            ))}
          </div>
        ) : (
          <>
            {sessions.map((session, i) => (
              <div className="kfjjek335" key={i}>
                {session.app_name === "Web" && <img src="/icons/web.png"></img>}
                <div className="jjfkvke3x">
                  <div>{session.system_name}</div>
                  <div>{session.app_name}</div>
                  <div>{session.location}</div>
                  <div>{session.date}</div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

export default Sessions;
